import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { func, string, element } from 'prop-types';
const Tab = /*#__PURE__*/forwardRef(function Tab(_ref, ref) {
  let {
    onChange,
    onClick,
    value,
    children: childrenProp
  } = _ref,
      other = _objectWithoutPropertiesLoose(_ref, ["onChange", "onClick", "value", "children"]);

  const handleClick = event => {
    onChange(event, value);
    onClick(event);
  };

  if (! /*#__PURE__*/React.isValidElement(childrenProp)) return null;
  const children = /*#__PURE__*/React.cloneElement(childrenProp, Object.assign({}, other));
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    ref: ref
  }, children);
});
Tab.defaultProps = {
  onClick: () => ({})
};
process.env.NODE_ENV !== "production" ? Tab.propTypes = {
  onChange: func,
  onClick: func,
  value: string,
  children: element
} : void 0;
export default Tab;